export const UserRoles = {
    Admin: { id: 1, name: 'Administrador' },
    Graduate: { id: 2, name: 'Graduado' },
}

export enum RegisterFormInfoTypes {
    Register,
    Personal,
    Professional,
    Educational,
}

export const Country = {
    Argentina: 0,
    Alemania: 1,
    Australia: 2,
    Austria: 3,
    Belgica: 4,
    Bolivia: 5,
    Brasil: 6,
    Canada: 7,
    Chile: 8,
    China: 9,
    Colombia: 10,
    CostaRica: 11,
    Croacia: 12,
    Dinamarca: 13,
    Ecuador: 14,
    España: 15,
    'Estados Unidos': 16,
    Francia: 17,
    India: 18,
    Irlanda: 19,
    Italia: 20,
    Japon: 21,
    Mexico: 22,
    'Paises Bajos': 23,
    Paraguay: 24,
    Peru: 25,
    Portugal: 26,
    'Reino Unido': 27,
    Rusia: 28,
    Suiza: 29,
    Uruguay: 30,
    Venezuela: 31,
    Otro: 32,
}

export const months = {
    1: 'Enero',
    2: 'Febrero',
    3: 'Marzo',
    4: 'Abril',
    5: 'Mayo',
    6: 'Junio',
    7: 'Julio',
    8: 'Agosto',
    9: 'Septiembre',
    10: 'Octubre',
    11: 'Noviembre',
    12: 'Diciembre',
}
